import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
const AVATAR_COLORS = ['#3A3F8F', '#5B34B0', '#0F6B63', '#8A4B06', '#B42318', '#1E7A4C'];
/** Deterministic per-name color, matching how Sidebar/Topbar already pick
 * the "AM" avatar's indigo without a per-user stored color — a hash of the
 * name, not random, so the same person is always the same color across
 * renders. */
function colorFor(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i += 1)
        hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
function initialsOf(name) {
    return (name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((p) => p[0]?.toUpperCase())
        .join('') || '?');
}
const SIZE_CLASSES = { xs: 'size-5 text-[9px]', sm: 'size-6 text-[10px]', md: 'size-8 text-xs', lg: 'size-10 text-sm' };
export function Avatar({ name, size = 'md', className }) {
    return (_jsx("span", { title: name, className: clsx('flex shrink-0 items-center justify-center rounded-full font-semibold text-white', SIZE_CLASSES[size], className), style: { backgroundColor: colorFor(name) }, children: initialsOf(name) }));
}
/** Overlapping avatar stack (docs/architecture/37 § Avatars) — e.g. a
 * deal's watchers, a team's members. `max` caps how many render before
 * folding the rest into a "+N" pill. */
export function AvatarStack({ names, max = 4, size = 'sm' }) {
    const shown = names.slice(0, max);
    const overflow = names.length - shown.length;
    return (_jsxs("div", { className: "flex items-center", children: [shown.map((name, i) => (_jsx(Avatar, { name: name, size: size, className: clsx('ring-2 ring-surface', i > 0 && '-ml-2') }, `${name}-${i}`))), overflow > 0 && (_jsxs("span", { className: clsx('-ml-2 flex items-center justify-center rounded-full bg-surface-subtle font-semibold text-text-secondary ring-2 ring-surface', SIZE_CLASSES[size]), children: ["+", overflow] }))] }));
}
//# sourceMappingURL=Avatar.js.map